export default __webpack_public_path__ + "static/media/dukeCaseStudy.0fec33ca.png";